import React, { useCallback, useEffect, useState } from 'react';
import { Background, Content, Header, Icon, Button, FormDiv } from './styles';
import { FaTimes } from 'react-icons/fa';
import InputComponent from '../../Input';
import TextAreaComponent from '../../TextArea';
import { useSelector, useDispatch } from 'react-redux';
import {
  sendEmail,
  clearSentEmailStatus,
} from '../../../store/contacts/actions';
import Loading from '../../Loading';
import { toast } from 'react-toastify';
import Toast from '../../Toast';
import { navigationUrl } from '../../../store/analytic/actions';

interface IModal {
  handlerClose: () => void;
}

function Modal({ handlerClose }: IModal) {
  const dispatch = useDispatch();
  const [emailError, setEmailError] = useState(false);
  const [email, setEmail] = useState(
    useSelector(
      (state: ApplicationState) =>
        (state.auth as AuthState).userConfirmedData?.email || ''
    )
  );

  const [assuntoError, setAssuntoError] = useState(false);
  const [assunto, setAssunto] = useState('');

  const [messageError, setMessageError] = useState(false);
  const [message, setMessage] = useState('');

  const [loading, setLoading] = useState(false);
  const cpf = useSelector(
    (state: ApplicationState) => (state.auth as AuthState).user?.cpf || ''
  );
  const sentEmailStatus = useSelector(
    (state: ApplicationState) => state.contacts.sentEmailMessage
  );
  const agreement = useSelector(
    (state: ApplicationState) => state.contract.contractInformations
  );

  useEffect(() => {
    dispatch(clearSentEmailStatus());
    dispatch(
      navigationUrl.request({
        action: '/abreEnviarEmail',
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (sentEmailStatus) {
      setLoading(false);
      if (sentEmailStatus === 'Falha ao enviar e-mail.') {
        dispatch(clearSentEmailStatus());
        toast.error(
          <Toast title={'Aviso'} description={'Falha ao enviar e-mail'} />
        );
      } else {
        dispatch(clearSentEmailStatus());
        handlerClose();
        toast.error(
          <Toast title={'Aviso'} description={'E-mail enviado com sucesso!'} />
        );
      }
    }
  }, [sentEmailStatus, dispatch, handlerClose]);

  const handleEmailValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleEmailExit = useCallback(() => {
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    setEmailError(!re.test(email));
  },[email]);

  const handleAssuntoValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAssunto(e.target.value);
  };

  const handleAssuntoExit = useCallback(() => {
    setAssuntoError(assunto === '');
  },[assunto]);

  const handleMessageValue = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value);
  };

  const handleMessageExit = useCallback(() => {
    setMessageError(message === '');
  },[message]);

  const handleNaN = (value?: number | null) => {
    if (value === null || value === undefined) return null;
    else return value;
  };

  const handler = (e: any) => {
    e.target.id === 'background' && handlerClose();
  };

  const handleSendEmail = useCallback(() => {
    if (loading) return;
    handleEmailExit();
    handleAssuntoExit();
    handleMessageExit();
    if (
      email === '' ||
      assunto === '' ||
      message === '' ||
      emailError ||
      assuntoError ||
      messageError
    )
      return;

    setLoading(true);
    dispatch(
      sendEmail.request({
        cpf,
        emailFinanciado: email.trim(),
        texto: message.replace(/(?:\r\n|\r|\n)/g, '<br/>'),
        assunto,
        credorId: handleNaN(agreement?.creditorId),
        databaseId: handleNaN(agreement?.databaseId),
      })
    );
  }, [
    agreement,
    message,
    email,
    assunto,
    assuntoError,
    messageError,
    dispatch,
    loading,
    cpf,
    emailError,
    handleEmailExit,
    handleAssuntoExit,
    handleMessageExit,
  ]);

  return (
    <Background id='background' onClick={(e) => handler(e)}>
      <Content>
        <Header>
          <div className='close' onClick={handlerClose}>
            Fechar
          </div>
          <div className='title'>Contato por e-mail</div>
          <div className='ghost' />
          <Icon onClick={handlerClose}>
            <FaTimes style={{ height: 18, width: 16 }} />
          </Icon>
        </Header>
        <FormDiv>
          <div className={'default2'}>
            <span className={'color-black'}>
              Preencha os dados abaixo e envie-nos um e-mail:
            </span>
          </div>
          <div className={'default2'}>
            <span>Seu e-mail:</span>
            <InputComponent
              value={email}
              handlerOnchange={handleEmailValue}
              error={emailError}
              errorMessage={'E-mail inválido'}
              height={'48px'}
              onBlur={handleEmailExit}
            />
          </div>
          <div className={'default2'}>
            <span>Assunto:</span>
            <InputComponent
              value={assunto}
              handlerOnchange={handleAssuntoValue}
              error={assuntoError}
              errorMessage={'Preencha o assunto'}
              height={'48px'}
              onBlur={handleAssuntoExit}
            />
          </div>
          <div className={'default2'}>
            <span>Mensagem:</span>
            <TextAreaComponent
              handlerOnchange={handleMessageValue}
              error={messageError}
              errorMessage={'Preencha a mensagem'}
              height={'100px'}
              value={message}
              onBlur={handleMessageExit}
            />
          </div>
          <Button onClick={handleSendEmail}>
            {loading ? <Loading /> : 'Enviar'}
          </Button>
        </FormDiv>
      </Content>
    </Background>
  );
}

export default Modal;
